import { Injectable, Pipe } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FormControl, ValidationErrors, AbstractControl, ValidatorFn } from '@angular/forms';

import { environment } from 'src/environments/environment';
import { DwGoogleApi } from 'src/app/providers/dmp.googleapi.service';
import { DWNavigationService } from 'src/common/dw_navigation_service';
import * as dayjs from 'dayjs';
const baseApiUrl = environment.base.baseUrl;

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  static get parameters() {
    return [[HttpClient],[CommonLib]];
  }

  constructor(
    public http: HttpClient,
    // private CL: CommonLib,
  ) {
  }

  exec(method: string, header: HttpHeaders | null = null, url: string, params: any) :Observable<any> {
    return this._exec(method, header, url, params);
  }

  private _exec(method: string, header: HttpHeaders | null = null, url: string, params: any) :Observable<any> {
    console.log("## API:exec:"+url);
    let o = this;

    var response : any;
    switch (method) {
    case "GET":
      response = this._execGet(header, url, params);
      break;
    case "POST":
      response = this._execPost(header, url, params);
      break;
    case "PUT":
      response = this._execPut(header, url, params);
      break;
    case "DELETE":
      response = this._execDelete(header, url, params);
      break;
    }

    var obs = new Observable(observer => {
      var obb = observer;
      response.subscribe(
        (data: HttpResponse<any>) => {
          console.log("# API:result:", data.body);
          obb.next(data.body);
          obb.complete();
        },
        (error: HttpErrorResponse) => {
          console.log("## API:error:"+error.status);
          switch (error.status) {
          case 401:
            console.log("## HTTP 401");
            // if (error.error && error.error.ResultCode && error.error.ResultCode == 100) {
            //   if (this.CL.refreshToken) {
            //     // getToken処理を行い、処理を継続する。
            //     this._getTokenAndRetry(path, data, contentType, observer);
            //   }
            //   break;
            // }
            break;
          case 500:
            console.log("## HTTP 500");
            break;
          case 502:
            console.log("## HTTP 502");
            break;
          }
          obb.error(error);
          obb.complete();
        }
      );
    });

    return obs;
  }

 // RefreshTokenを利用してAccessTokenを取得し、再度元のAPIを実行する。
  // この際(getToken)、401の場合は機種変更のため、Welcome画面に戻る。
  private _getTokenAndRetry(){
    // console.log("## API:exec Refresh Token!! : start");
    // const o = this;
    //     let data = {
    //       "WalletID": o.CL.walletid,
    //       "RefreshToken": o.CL.refreshToken
    //     }
    //     if(o.CL.walletid && o.CL.refreshToken) {
    //       o.CL.getToken(o.CL.walletid, o.CL.refreshToken).then((token) => {
    //         console.log("## API:exec Refresh Token!! ok :"+token);
    //         //ここでリトライ

    //       }).catch((err) => {

    //       })
    //     }

    //     this._execPost('getToken', data, null, null, false).subscribe(
    //       token => {
    //         console.log("## API:exec Refresh Token!! ok :"+token);
    //         //ここでリトライ
    //         this._exec(method, name, params, false, optPath, optTKey, opt).subscribe(
    //           res => {
    //             console.log("## API:exec Refresh token retry ok.")
    //             returnObserver.next(res);
    //             returnObserver.complete();
    //             this.nowGetToken = false;
    //           },
    //           error => {
    //             if (error.error && error.error.ResultCode && error.error.ResultCode == 100) {
    //               // this.events.publish("common:event", "expire");
    //             }
    //             returnObserver.error(error);
    //             returnObserver.complete();
    //             this.nowGetToken = false;
    //           console.log("## API:exec Refresh token retry error.")
    //           });
    //       },
    //       error => {
    //         console.log("## API:exec Refresh Token!! error :"+error.status);
    //         this.nowGetToken = false;
    //         if (error.status == 503) {
    //           this.events.publish("common:event", "mainte");
    //         } else if (error.status == 401) {
    //           this.events.publish("common:event", "expire");
    //         } else {
    //         }
    //         // ここでreturnObserverのerrorを呼び出す必要があるか、テストする。
    //         returnObserver.error(error);
    //         returnObserver.complete();
    //         this.nowGetToken = false;
    //       }
    //     );
  }


  // GET
  private _execGet(header: HttpHeaders | null = null, url: string, params: any) {
    console.log("## GET:" + url + 'params :' + JSON.stringify(params));
    const o = this;
    let _url = baseApiUrl + url;

    const searchParams = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    if (searchParams != '') {
      _url = _url + '?' + searchParams;
    }
    let _headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    if(header) {
      _headers = header;
    }
    var response = this.http.get(_url, { headers: _headers, withCredentials: true , observe: 'response'});
    return response;
  }

  // POST
  private _execPost(header: HttpHeaders | null = null, url: string, params: any) {
    console.log("## POST:" + url + ': ' + JSON.stringify(params));
    let _url = baseApiUrl + url;
    let searchParams = "";

    if(url.includes("/EWA/Wallet/Token")) {
      searchParams = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');
      if (searchParams != '') {
        params = searchParams;
      }
    }

    let _headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    if(header) {
      _headers = header;
    }
    var response = this.http.post(_url, params, { headers: _headers, withCredentials: true , observe: 'response'});
    return response;
  }

  private _execPut(header: HttpHeaders | null = null, url: string, params: any) {
    console.log("## PUT:"+url + ': ' + JSON.stringify(params));
    let _url = baseApiUrl + url;

    const searchParams = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    if (searchParams != '') {
      _url = _url + '?' + searchParams;
    }
    let _headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    if(header) {
      _headers = header;
    }
    var response = this.http.put(_url, params, { headers: _headers, withCredentials: true, observe: 'response' });
    return response;
  }

  // DELETE
  private _execDelete(header: HttpHeaders | null = null, url: string, params: any) {
    console.log("## DELETE:" + url + ': ' + params);
    let conf;
    let _url = baseApiUrl + url;
    const searchParams = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    if (searchParams != '') {
      _url = _url + '?' + searchParams;
    }
    let _headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    if(header) {
      _headers = header;
    }
    var response = this.http.delete(_url, { headers: _headers, withCredentials: true , observe: 'response'});
    return response;
  }

}

@Injectable({
  providedIn: 'root'
})
export class JsonService {
  headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded', 'Cache-Control': 'no-cache'});

  private memCache: {[key: string]: any} = {};
  private CACHE_KEY = '____cached_content____';

  static get parameters() {
    return [[HttpClient]];
  }

  constructor(
    public http: HttpClient,
  ) {
  }

  public isCache(data: any): boolean {
    if (!data) return false;
    if (data[this.CACHE_KEY] == true) {
      return true;
    }
    return false;
  }

  public execGetJson(name: string) {
    let defLang = 'ja';
    let KEYWORD = '{{VLANG}}';
    if (name.indexOf(KEYWORD) === -1) {
      return this.execGetJsonImpl(name);
    }
    return new Observable<any>(observer => {
      let url = name;
      this.execGetJsonImpl(url)
      .subscribe(
        {
          next: (res:any) => {
            observer.next(res);
            observer.complete();
          },
          error: (err) => {
            console.log('#############' + err.status);
            if (err.status === 404) {
              let url = name.replace(KEYWORD, defLang);
              this.execGetJsonImpl(url).subscribe({
                next: (res: any) => {
                  observer.next(res);
                  observer.complete();
                },
                error: (err: any) => {
                  observer.error(err);
                  observer.complete();
                }
              });
            } else {
              observer.error(err);
              observer.complete();
            }
          }
        });
    });
  }

  private execGetJsonImpl(name: string) {
    let url = name;
    if (name.indexOf('http:') === 0 || name.indexOf('https://') === 0 || name.indexOf('assets/') === 0) {
      url = name;
    } else {
      url = environment.base.resouceUrl + name;
    }
    if (name.indexOf('?') === -1) {
      url += '?' + Math.random();
    }
    // 設定ファイルにリトライ回数記載してあるので、設定ファイル自体を取得するのは決め打ちで記載
    // let response = this.http.get(url, this.options).retry(3).map(res => res.json());
    return new Observable<any>(observer => {
      this.http.head(url, { headers: this.headers, withCredentials: true, observe: 'response' })
       .subscribe({
        next: (res) => {
          let lmod = res.headers.get('last-modified');
          let ch = this.memCache[name];
          if (ch) {
            if (ch.lm === lmod) {
              ch.data[this.CACHE_KEY] = true;
              observer.next(ch.data);
              observer.complete();
              return;
            }
          }
          this.http.get(url, { headers: this.headers, withCredentials: true, observe: 'response' })
          .subscribe({
            next: (res1) => {
              // console.log('##### デバッグログ:http.get正常戻り')
              if (name.indexOf('?') === -1) {
                // メモリ使い潰さないように
                console.log('####:execGetJson url:[' + url + ']');
                let data;
                try {
                  data = res1.body;
                } catch (ex) {
                  observer.error(res1);
                  observer.complete();
                  return;
                }
                this.memCache[name] = {
                  data: data,
                  lm: lmod
                };
              }
              observer.next(res1.body);
              observer.complete();
            },
            error: (err) => {
              // console.log('##### デバッグログ:http.getエラー', JSON.stringify(err))
              observer.error(err);
              observer.complete();
            }
          })
        },
        error: (err) => {
          // console.log('##### デバッグログ:http.headエラー', JSON.stringify(err))
          observer.error(err);
          this.http.get(url, { headers: this.headers, withCredentials: true, observe: 'response' })
          .subscribe({
            next: (res1) => {
              // console.log('##### デバッグログ:http.get正常戻り')
              if (name.indexOf('?') === -1) {
                // メモリ使い潰さないように
                console.log('####:execGetJson url:[' + url + ']');
                let data;
                try {
                  data = res1.body;
                } catch (ex) {
                  observer.error(res1);
                  observer.complete();
                  return;
                }
              }
              observer.next(res1.body);
              observer.complete();
            },
            error: (err) => {
              // console.log('##### デバッグログ:http.getエラー', JSON.stringify(err))
              observer.error(err);
              observer.complete();
            }
          })
        }
      })
    });
  }


}

interface ConfigCampaign {
  contactInfo: string
}
interface Config {
  env: string,
  campaign: ConfigCampaign,
  force_update: any
}

@Injectable({
  providedIn: 'root'
})
export class CommonLib {
  pagePath: string = "";
  walletid: number | undefined;
  refreshToken: string = "";
  tenantId: number | string = 0;
  itemId: number | null = null;
  eventId: number | null = null;
  eventKey: string = "";
  itemType: string | null = null;
  personalInfo: PersonalInfoType = {
    snsAccountName: "",
    surName: "",
    givenName: "",
    surNameKana: "",
    givenNameKana: "",
    nameKana: "",
    postcode1: "",
    postcode2: "",
    zip: "",
    state: "",
    town: "",
    address1: "",
    address2: "",
    tel: "",
    tel1: "",
    tel2: "",
    tel3: "",
    mail: "",
    mail2: "",
    inquiryMsg: "",
  }


  configJson: Config = {
    env: "",
    campaign: {
      contactInfo: ""
    },
    force_update: {}
  };

  static get parameters() {
    return [[ApiService], [DwGoogleApi], ];
  }

  constructor(
    private AP: ApiService,
    private gcp: DwGoogleApi,
    private nav: DWNavigationService,
  ) {
  }

  /**
   * クエリパラメータから遷移先を取得
   */
  getNextPage(query: string) {
    const o = this;
    let pageUrl = "/";
    let gaP: any = {};

    if(environment.base.appname === "preview") {
      return "/coupon-mobapro";
    }

    try {
      if (query != null && query != undefined) {
        let cn = "";
        let key = "";
        let c;
        let t;
        let qp: any = {};
        query.split('&').forEach((kv: string) => {
          let _kv = kv.split('=');
          let _k = _kv[0];
          let _v = _kv[1];
          qp[_k] = _v;
          console.log(`kv = ${_k}:${_v}`);
          if(_k === "cn") {
            if (_v) {
              cn = _v;
            }
          }
          if(_k === "it") {
            if (_v) {
              o.itemType = _v;
            }
          }
          if (_k == 'ik') {
            if (_v) {
              key = _v;
            }
          }
          if(_k === "c") {
            if (_v) {
              c = Number(_v);
            }
          }
          if(_k === "t") {
            if (_v) {
              t = Number(_v);
            }
          }
  
          // gaのキャンペーン
          if(_k === "dwga_cid") {
            gaP["campaign_id"] = _v;
          }
          if(_k === "dwga_cname") {
            gaP["campaign_name"] = _v;
          }
          if(_k === "dwga_csource") {
            gaP["campaign_source"] = _v;
          }
          if(_k === "dwga_cmedium") {
            gaP["campaign_medium"] = _v;
          }
        });
        switch(Number(o.itemType)) {
          case 27:
            pageUrl = "/coupon-detail";
            if(environment.base.appname === "mobaprocoupon") {
              return "/coupon-mobapro";
            }
            break;
          case 41:
            pageUrl = "/form-input"
            break;
        }
  
        if(cn === "dw") {
          o.eventKey = key;
          o.eventId = c || null;
          o.tenantId = t || environment.tenantid;
          o.nav.queryP = qp;
  
        } else if(cn === "version") {
          pageUrl = "/version"
        }
      }
  
      if(gaP.campaign_id && gaP.campaign_name && gaP.campaign_source && gaP.campaign_medium) {
        const param = {
          campaign_id: gaP.campaign_id,
          campaign_name:  gaP.campaign_name,
          campaign_source: gaP.campaign_source,
          campaign_medium: gaP.campaign_medium
        }
        o.gaSetGlobal(param);
        o.gaSetGlobalUserPropaty({campaign_ads: param.campaign_name});
        o.gaSetUserIDCampaign(param.campaign_name);
      }
    } catch(e) {console.error(e)}

    return pageUrl
  }

//--------- 暁さん向け ---------
   akatsukiUrlParam: {[key: string]: string} = {
    id: "",
    jwt: ""
  };
  jwtObj: JwtDataType = {
    "did": "",
    "value": ""
  };

  /**
   * クエリパラメータから遷移先を取得
   */
  setAkatsukiUrlQuery(query: string) {
    const o = this;
    if (query == null || query === undefined || query === '') {
      return;
    }
    // # 以降はクエリではない（hash が query に混ざるのを防ぐ）
    let q = query;
    if (q.indexOf('#') >= 0) {
      q = q.split('#')[0];
    }
    q.split('&').forEach((kv: string) => {
      const eq = kv.indexOf('=');
      if (eq < 0) {
        return;
      }
      const _k = kv.substring(0, eq);
      // jt/jwt の値に = が含まれる（Base64 パディング等）ため split('=')[1] は使わない
      const _v = kv.substring(eq + 1);
      if (_k === 'id' && _v) {
        o.akatsukiUrlParam['id'] = _v;
      }
      if (_k === 'jt' && _v) {
        o.akatsukiUrlParam['jwt'] = _v;
      }
    });
  }

  /**
   * jwtのキーから値を検索
   */
  findJwtKeyValue(jwtStr: string, key: string) {
    try {
      if (jwtStr == null || jwtStr === '') {
        return '';
      }
      const segment = jwtStr.split('|').find((s: any) => s.startsWith(`${key}=`));
      if (!segment) {
        return '';
      }
      // 値に = が含まれうるため先頭の key= の後ろをまとめて取る
      const prefix = `${key}=`;
      const retrunVal = segment.startsWith(prefix)
        ? segment.substring(prefix.length)
        : '';
      return retrunVal;
    } catch(err) {
      console.error(err);
      return "";
    }
  }

  //---------------------------

  setConfigJson(params: Config) {
    const o = this;
    o.configJson = params;
  }

  setEventKey(val: string) {
    this.eventKey = val;
  }

  getEventKey() {
    return this.eventKey
  }

  crearData() {
    const o = this;
    o.walletid = undefined;
    o.itemId = null;
    o.eventId = null;
    o.eventKey = "";
    o.itemType = null;
    o.personalInfo.snsAccountName = "";
    o.personalInfo.surName = "";
    o.personalInfo.givenName = "";
    o.personalInfo.surNameKana = "";
    o.personalInfo.givenNameKana = "";
    o.personalInfo.nameKana = "";
    o.personalInfo.postcode1 = "";
    o.personalInfo.postcode2 = "";
    o.personalInfo.zip = "";
    o.personalInfo.state = "";
    o.personalInfo.town = "";
    o.personalInfo.address1 = "";
    o.personalInfo.address2 = "";
    o.personalInfo.tel = "";
    o.personalInfo.tel1 = "";
    o.personalInfo.tel2 = "";
    o.personalInfo.tel3 = "";
    o.personalInfo.mail = "";
    o.personalInfo.mail2 = "";
  }

  /**
 * 登録されているValueを取得
 * @param key 
 */
  getKeyValue(key: string) {
    return new Promise<any>((resolve, reject) => {
      const o = this;
      const p = {
        TenantID: o.tenantId || environment.tenantid,
        Key: key,
        IsRemove: false,
      }
      o.AP.exec("GET", null, "/EWA/KV", p).subscribe({
        next: (res: any) => {
          console.log("##### getKeyValue res:" + JSON.stringify(res));
          resolve(res)
        },
        error: (err: any) => {
          console.log(err);
          reject(err)
        }
      })
    })
  }


  /**
   * ゲストwalletID作成
   */
  createGuestWalletID(name: string) {
    const o = this;
    return new Promise<any>((resolve, reject) => {
      const param: any = {
        Name: name,
        TenantID: o.tenantId || environment.tenantid,
      }
      o.AP.exec("PUT", null, "/EWA/Wallet", param).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (err) => {
          reject(err)
        }
      })
    })
  }

  /**
   * ゲストwalletID取得
   */
  getGuestWalletID() {
    const o = this;
    return new Promise<any>((resolve, reject) => {
      o.AP.exec("GET", null, "/EWA/WalletID", {}).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (err) => {
          reject(err)
        }
      })
    })
  }

  /**
   * アクセストークン取得
   */
  getToken(walletid: number, refToken: string) {
    const o = this;
    return new Promise<any>((resolve, reject) => {
      const param: any = {
        WalletID: walletid,
        RefreshToken: refToken,
        TenantID: o.tenantId || environment.tenantid,
      }
      o.AP.exec("POST", null, "/EWA/Wallet/Token", param).subscribe({
        next: (res: any) => {

          resolve(res);
        },
        error: (err) => {
          reject(err)
        }
      })
    })
  }

  /**
   * item情報取得
   */
  getItemInfo(itemid: string | number) {
    return new Promise<any>((resolve, reject) => {
      const o = this;
      const p = {
        TenantID: o.tenantId || environment.tenantid,
        // MerchantID: 1,
        Type: Number(o.itemType),
      }
      o.AP.exec("GET", null, `/EWA/Item/${itemid}`, p).subscribe({
        next: (res) => {
          console.log("##### getItemInfo res:" + JSON.stringify(res));
          resolve(res)
        },
        error: (err) => {
          console.log("##### getItemInfo error:" + err);
          reject(err)
        }
      });
    })
  }

    /**
   * クーポンイベントのitem情報取得
   */
  getCouponEventItemInfo(itemid: string | number) {
    return new Promise<any>((resolve, reject) => {
      const o = this;
      const p = {
        TenantID: o.tenantId || environment.tenantid,
        // MerchantID: 1,
        Type: 22,
        TypeID: itemid,
        Offset: 0,
        Limit: 1,
        // ShowHidden: 3
      }
      o.AP.exec("GET", null, `/EWA/Item`, p).subscribe({
        next: (res) => {
          console.log("##### getItemInfo res:" + JSON.stringify(res));
          if(res && res.Results && res.Results.length > 0) {
            resolve(res.Results[0])
          }
          else {
            resolve("")
          }
        },
        error: (err) => {
          console.log("##### getItemInfo error:" + err);
          reject(err)
        }
      });
    })
  }

  /**
   * シナリオ実行
   */
  postScenarioAction(walletId: number, actionId: number,actionParam: any = {}) {
    const o = this;
    return new Promise<any>((resolve, reject) => {
      let p = {
        "WalletID": walletId,
        "TenantID": o.tenantId || environment.tenantid,
        "ActionID": actionId,
        "Stub": true,
        "ActionParam":actionParam,
      }
      const header = new HttpHeaders({ 'Content-Type': 'application/json' });

      console.log(JSON.stringify(p))

      o.AP.exec("POST", header, `/EWA/Wallet/${walletId}/ScenarioAction`, p).subscribe({
        next: (res) => {
          console.log("##### execScenarioAction res:" + JSON.stringify(res));
          resolve(res)
        },
        error: (err) => {
          console.log("##### execScenarioAction error:" + err);
          reject(err)
        }
      })
    })
  }

  // gcpのログ送信
  gcpLogSent(walletid: number = 0, type:string, v1:string="",v2:string="",v3:string="",v4:string="") {
    const o = this;
    if(o.gcp.getTenant() === 0) {
      o.gcp.setTenant(Number(o.tenantId));
    }
    o.gcp.sendlog(walletid, type, v1, v2, v3, v4);
  }

  // GA tag系
  // set id
  gaSetGlobal(param: any = {}) {
    if(!gtag) return;
    console.log("ga set global param :" , param)
    gtag('set', param);
  }

  gaSetGlobalUserPropaty(param: any = {}) {
    if(!gtag) return;
    console.log("ga set global user propatis :" , param)
    gtag('set', 'user_properties',param);
  }

  gaSetUserIDCampaign(campaignName: string) {
    const userid = localStorage.getItem("USERID_" + campaignName);
    if(userid) {
      this.gaSetUserID(userid);
    }
    else {
      let userid = `${campaignName}_${dayjs().unix()}`;
      this.gaSetUserID(userid);
      localStorage.setItem("USERID_" + campaignName, userid)
    }
  }

  gaSetUserID(id: string) {
    if(!gtag) return;
    console.log("ga user register: ", id)
    gtag('set', {
      'user_id': id
    });
  }

  gaPageView(location: string, path: string, title: string, userid: string = "") {
    if(!gtag) return;
    console.log("ga send page :" , location, path, title)
    gtag('event', 'page_view', {
      page_title: title,
      page_location: location,
      page_path: path,
      page_user_id: userid
    });
  }

  gaCustomeEvent(event: string, param: {[key: string]: any}) {
    if(!gtag) return;
    console.log("ga send custome event :" , event, JSON.stringify(param));
    gtag('event', event, param);
  }

}


export class ValidationCheckService {
  //半角数字
  checkNum(val: any) {
    let regExp = /^[0-9]+$/;
    return regExp.test(val);
  }

  //半角英数字
  alphanum(val: any) {
    let regExp = /^[A-Za-z0-9]+$/;
  return regExp.test(val);
  }

  //半角英数字を１文字以上含む
  alphanumOne(val: any) {
    let reg = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i
    return reg.test(val);
  }

  //半角英字
  alpha(val: any) {
    let regExp = /^[A-Za-z]+$/;
    return regExp.test(val);
  }

  //半角英字と半角記号「!\"#$%&'()~|`{}?_<>=^@[];:,.+-*/」）
  alphasymbol(val: any) {
    let regExp = /^[-a-zA-Z!"#$%&'\(\)~|`\{\}?_<>=^@\[\];:,.+\-*\/]+$/;
    return regExp.test(val);
  }

  //半角英数記号+ラテン文字（Unicode u0020〜u007e, u00a0〜u00ff）
  alphanumsymbol(val: any) {
    let regExp = /^[\u0020-\u007E\u00A0-\u00FF]+$/;
    return regExp.test(val);
  }

  //有効なメールアドレスを入力してください。
  email(val: any):boolean {
    let regExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regExp.test(val);
    //alert("You have entered an invalid email address!")
  }

  // tel
  tel(val: any): boolean {
    let regExp = /^0[0-9\-\(\)]{11,13}$/;
    return regExp.test(val);
  }

  //全角カタカナ
  fullKana(val: any):boolean {
    let regExp =/^[ァ-ヶー]+$/;
    return regExp.test(val);
  }

  //半角カタカナ
  halfKana(val: any):boolean {
    let regExp =/^[ｦ-ﾟ]+$/;
    return regExp.test(val);
  }

  // ------------------
  // angular バリデーション

  // 空白文字のみチェック
  noWhitespaceValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let isWhitespace = (control.value || '').trim().length === 0;
      isValid = !isWhitespace;
    }
    return isValid ? null : { 'whitespace': true }
  }

  // 半角数字
  checkHalfNumValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let regExp = /^[0-9]+$/;
      isValid = regExp.test(control.value);
    }
    else {
      isValid = true;
    }
    return isValid ? null : { 'halfNum': true }
  }

  // 半角数字 先頭0以外始まり
  checkHalfNumNoFirstZeroValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let regExp = /^[1-9][0-9]*$/;
      isValid = regExp.test(control.value);
    } else {
      isValid = true;
    }
    return isValid ? null : { 'halfNumNoFirstZero': true }
  }

  // 半角数字 先頭0始まり
  checkHalfNumFirstZeroValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let regExp = /^0[1-9]*$/;
      isValid = regExp.test(control.value);
    } else {
      isValid = true;
    }
    return isValid ? null : { 'halfNumNoFirstZero': true }
  }

  // 全角カタカナ
  checkFullKanaValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let regExp =/^[ァ-ヶー]+$/;
      isValid = regExp.test(control.value);;
    }
    return isValid ? null : { 'fullKana': true }
  }

  // 半角カタカナ
  checkHalfKanaValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let regExp =/^[ｦ-ﾟ]+$/;
      isValid = regExp.test(control.value);;
    }
    return isValid ? null : { 'halfKana': true }
  }

  // email
  checkEmailValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let regExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      isValid = regExp.test(control.value);
    }
    return isValid ? null : { 'email': true }
  }

  // tel
  checkTelValidator(control: FormControl): ValidationErrors | null {
    let isValid = false;
    if (control.value && control.value.length > 0) {
      let regExp = /^0[0-9\-\(\)]{11,13}$/;
      isValid = regExp.test(control.value);
    }
    return isValid ? null : { 'tel': true }
  }
}


export interface PersonalInfoType {
  snsAccountName: string,
  surName: string,
  givenName: string,
  surNameKana:string,
  givenNameKana:string,
  nameKana: string,
  zip: string,
  postcode1: string,
  postcode2: string,
  state: string,
  town: string,
  address1: string,
  address2: string,
  tel: string,
  tel1: string,
  tel2: string,
  tel3: string,
  mail: string,
  mail2: string,
  inquiryMsg: string
}

export interface JwtDataType {
  did: string;
  value: string;
}